import { uncapitalize } from '@attain-apps/string-utils'

import * as core from '../../../../../../core'
import * as common from '../../../../../common'

import * as institutionType from './institution-type'

// NOTE: everything below is designed to simulate a normal folder/module
// structure for exporting resources from separate files. This just simply
// generates those resources based on the known enum entries

const enumId = core.dms.models.Enum.Id.from({
  partialId: institutionType.RESOURCE.payload.partialId,
})

const enumEntryResourceNameLookup = {} as Record<common.InstitutionType, string>
for (const enumEntryName in common.InstitutionType) {
  const potentialEnum =
    common.InstitutionType[enumEntryName as keyof typeof common.InstitutionType]
  if (common.InstitutionType.isInstitutionType(potentialEnum)) {
    enumEntryResourceNameLookup[potentialEnum] = uncapitalize(enumEntryName)
  }
}

export const entries = common.InstitutionType.ALL.reduce(
  (prev, _institutionType) =>
    Object.assign(prev, {
      [enumEntryResourceNameLookup[_institutionType]]: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        RESOURCE: {
          payload: {
            ...common.InstitutionType.getEntry(_institutionType),
            enumId,
          },
          type: core.quiver.Resource.Type.DmsEnumEntry,
        } as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>,
      },
    }),
  {} as {
    [K in keyof typeof common.InstitutionType as (typeof common.InstitutionType)[K] extends common.InstitutionType
      ? Uncapitalize<K>
      : never]: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      RESOURCE: core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
    }
  },
)
